import { createFeatureSelector } from '@ngrx/store';
import { FeatureState } from './state';

export const featureKey = 'notificationsFeature';

export const selectFeatureState = createFeatureSelector<FeatureState>(featureKey);
